import { Endpoint } from '../endpoint';

export const ElementVersionProcessingRule = new Endpoint('element_version_processing_rule');
